var LogoutReason;
(function (LogoutReason) {
  LogoutReason["CREDENTIALS_EXPIRED"] = "credentials-expired";
  LogoutReason["USER_INITIATED"] = "user-initiated";
})(LogoutReason || (LogoutReason = {}));

export { LogoutReason as L };
